import { Flex, Heading, Image } from "@chakra-ui/react";
import React from "react";
import { FormattedMessage } from "react-intl";
import { NavLink } from "react-router-dom";
import LangButtons from "../../LangButtons/LangButtons";
import NavbarButton from "../../NavbarButton/NavbarButton";

const NavbarMobile = ({ setVisible, visible, isRegistered, logout }) => {

  return (
    <>
      <NavbarButton setVisible={setVisible} />
      <Flex
        w={visible ? "100%" : "0%"}
        transition="width, 1s"
        h="100%"
        position="absolute"
        right={0}
        overflow="hidden"
        backgroundColor="#211f20"
        justify="space-between"
        flexDir="column"
        align="center"
        pb={visible ? "5rem" : "20rem"}
        pt="10px"
        zIndex="3"
      >
        <LangButtons layout="mobile"/>
        <NavLink to="/" onClick={() => setVisible(false)}>
          <Image
            w="100%"
            src="https://res.cloudinary.com/dhp2zuftj/image/upload/v1650051041/MontseProyect/logoNegro.png"
            alt="icono KLS"
          />
        </NavLink>
        <NavLink to="/" onClick={() => setVisible(false)}>
          <Heading color="#f2f4f6"> <FormattedMessage id="app.navbar.inicio"/></Heading>
        </NavLink>
        <NavLink to="/novedades" onClick={() => setVisible(false)}>
          <Heading color="#f2f4f6"><FormattedMessage id="app.navbar.novedades"/></Heading>
        </NavLink>
        <NavLink to="/ganadores" onClick={() => setVisible(false)}>
          <Heading color="#f2f4f6"><FormattedMessage id="app.navbar.ganadores"/></Heading>
        </NavLink>
        <NavLink to="/contacto" onClick={() => setVisible(false)}>
          <Heading color="#f2f4f6"><FormattedMessage id="app.navbar.contacto"/></Heading>
        </NavLink>
        {isRegistered ? (
            <Image
                filter="brightness(0) invert(1)"
                w="40px"
                cursor="pointer"
                onClick={() => logout()}
                src="https://www.svgrepo.com/show/67681/logout.svg"
                alt="logout"
              />
        ) : (
          <NavLink to="/login" onClick={() => setVisible(false)}>
            <Heading color="#f2f4f6">Login</Heading>
          </NavLink>
        )}
      </Flex>
    </>
  );
};

export default NavbarMobile;